import React from 'react';

const FacebookLogoSvg = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 71.7 71.8"
    className="facebook-logo"
    style={{ fill: props.fill }}
  >
    <path
      className="a"
      d="M67.7,0H4A4.012,4.012,0,0,0,0,4V67.8a4.012,4.012,0,0,0,4,4H38.3V43.9H29V33.1h9.3v-8c0-9.3,5.7-14.3,13.9-14.3,4,0,7.4.3,8.3.4v9.7H54.8c-4.5,0-5.4,2.1-5.4,5.3v6.9H60.1L58.7,43.9H49.4V71.7H67.7a4.012,4.012,0,0,0,4-4V4A4.012,4.012,0,0,0,67.7,0Z"
    />
  </svg>
);

export default FacebookLogoSvg;
